import {Component, OnInit} from '@angular/core';
import {ClientService} from 'src/app/services/client.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationService} from '../../services/notification.service';
import {ClientDTO} from '../../model/clientDTO';
import {MigrationService} from '../../services/migration.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit {

  client: ClientDTO;
  isLoading = false;

  constructor(
    private clientService: ClientService,
    private dialog: MatDialog,
    private migrationService: MigrationService,
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.getClient(params['clientId']);
      this.shouldMigrate(params['clientId']);
    });
  }

  getClient(id) {
    this.isLoading = true;
    this.clientService.getOne(id).subscribe(res => {
      this.isLoading = false;
      this.client = res;
    }, error => {
      this.isLoading = false;
      this.notificationService.errorResponse(error);
      this.router.navigate([`/`]);
    });
  }

  private shouldMigrate(clientId) {
    this.migrationService.shouldMigrate(clientId).subscribe(value => {
      if (value.shouldMigrateClient) {
        const text = {
          header: 'verzoek om bewinddetails aan te vullen',
          body: 'voor de nieuwe versie van de rekening en verantwoording rapportage van de rechtspraak hebben wij aanvullende gegevens van u en uw bewind nodig. Wij verzoeken u vriendelijk bij bewind details en persoonsgegevens om deze gegevens aan te vullen.',
          ok: 'gegevens aanvullen'
        };
        this.notificationService.inform(text)
          .then(() => this.router.navigate(['/bewind/' + this.client.id + '/bewerken']));
      } else if (value.shouldMigrateUser) {
        const text = {
          header: 'verzoek om persoonsgegevens aan te vullen',
          body: 'voor de nieuwe versie van de rekening en verantwoording rapportage van de rechtspraak hebben wij aanvullende gegevens van u en uw bewind nodig. Wij verzoeken u vriendelijk bij bewind details en persoonsgegevens om deze gegevens aan te vullen.',
          ok: 'gegevens aanvullen'
        };
        this.notificationService.inform(text)
          .then(() => this.router.navigate(['/account-gegevens-bewerken']));
      }
    });
  }
}
